import Utils from './Utils'

class Cart {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._utils = new Utils()
        this.ShopifyAPI = window.ShopifyAPI
        this.LiveChatWidget = null
        try {
            this.LiveChatWidget = window.LiveChatWidget
        } catch (e) {
        }
    }

    onInit () {
        const _this = this
        _this.LiveChatWidget.call('hide')

        _this.LiveChatWidget.on('visibility_changed', function (data) {
            if (_this.LiveChatWidget.get('state').visibility !== 'hidden') {
                if (data.visibility === 'minimized') {
                    _this.LiveChatWidget.call('hide')
                }
            }
        })

        let variantSelectors = this._elem.querySelectorAll('.update-cart-selector')
        variantSelectors.forEach(function (el) {
            el.addEventListener('change', function () {
                let lineItem = _this._utils.getClosestParent(el, '.cart-line-item')
                _this.updateCart(lineItem)
            })
        })
        let updateButtons = this._elem.querySelectorAll('.update-cart-button')
        updateButtons.forEach(function (el) {
            el.addEventListener('click', function () {
                let lineItem = _this._utils.getClosestParent(el, '.cart-line-item')
                _this.updateCart(lineItem)
            })
        })
        this.removeFromCart()
        this.initCartNote()
        this.mobileInit()
        this.cartInitNumberInputs()
    }

    cartUpdateInputs (target, value) {
        target.value = value
        if (target.getAttribute('data-cart-button')) {
            let lineItem = target.getAttribute('data-cart-button')
            this.updateCart(this._elem.querySelector('#cart-line-item-' + lineItem), true)
        }
    }

    cartInitNumberInputs () {
        let _this = this
        let numberInputs = document.querySelectorAll('.cart-number-input')

        numberInputs.forEach(function (el) {
            let minus = el.querySelector('.number-input-minus')
            let plus = el.querySelector('.number-input-plus')
            let target = el.querySelector('.number-input-target')
            if (target && minus && plus) {
                minus.addEventListener('click', function () {
                    if (parseInt(target.value) > 1) {
                        _this.cartUpdateInputs(target, parseInt(target.value) - 1)
                    }
                })
                plus.addEventListener('click', function () {
                    _this.cartUpdateInputs(target, parseInt(target.value) + 1)
                })
            }
        })
    }

    updateCart (lineItem, submit = true) {
        let overlay = this._elem.querySelector('.image-overlay')
        let selectedObj = {'option1': null, 'option2': null, 'option3': null}
        let lineItemId
        let cartProducts
        let _this = this
        let cartProductsEl = this._elem.querySelector('#meta-cart')
        let checkoutButton = this._elem.querySelector('#checkout-button')

        if (cartProductsEl) {
            // Find selected variant
            lineItem.querySelectorAll('.cart-variant-selector').forEach(function (selected) {
                let selectedOptionName = selected.getAttribute('data-option-num')
                lineItemId = selected.getAttribute('data-line-item')
                cartProducts = JSON.parse(cartProductsEl.getAttribute('data-cart-' + lineItemId))
                selectedObj[selectedOptionName] = selected.value
            })

            let selectedVariant = cartProducts['variants'].find(x => x.option1 === selectedObj['option1'] && (x.option2 === selectedObj['option2'] || x.option2 === null) && (x.option3 === selectedObj['option3'] || x.option3 === null))

            if (selectedVariant && selectedVariant.available === true) {
                // Add overlay to block any more inputs
                if (overlay && submit) {
                    overlay.classList.remove('hide')
                }
                this._elem.querySelector(`#variants-${lineItemId}`).value = selectedVariant.id
                checkoutButton.setAttribute('disabled', 'false')
                checkoutButton.setAttribute('href', '/checkout')

                if (submit) {
                    _this.ShopifyAPI.changeItem(lineItemId, 0, () => _this.ShopifyAPI.addItemFromForm(`#form-${lineItemId}`, function (success) {
                        _this.updateCartPage()
                    }, function (failure) {
                        console.log(failure)
                        overlay.classList.add('hide')
                    }))
                } else {
                    // Show mobile submit button
                    let mobileSubmitCart = document.querySelector(`.mobile-overlay-submit[data-line-item="#cart-line-item-${lineItemId}"]`)
                    mobileSubmitCart.textContent = 'Update cart'
                    mobileSubmitCart.classList.add('fade-in-show')
                    mobileSubmitCart.classList.remove('hide-opacity-low')
                }
            } else {
                // Variant not purchasable, update as unavilable
                lineItem.querySelector('.product-price').innerHTML = 'Unavailable'
                lineItem.querySelector('.update-cart-button').classList.add('hide-opacity-low')
                overlay.classList.add('hide')
                checkoutButton.setAttribute('disabled', 'true')
                checkoutButton.setAttribute('href', '#')

                let mobileSubmitCart = document.querySelector(`.mobile-overlay-submit[data-line-item="#cart-line-item-${lineItemId}"]`)
                mobileSubmitCart.textContent = 'Unavailable'
                mobileSubmitCart.classList.add('fade-in-show')
                mobileSubmitCart.classList.add('hide-opacity-low')
            }
        }
    }

    updateCartPage () {
        let currentCartContainer = this._elem.querySelector('#cart-container')
        let currentCartOverlays = document.querySelectorAll('.cart-overlay')
        let currentCartSticky = document.querySelector('#cart-sticky-price')
        let siteHeader = document.querySelector('#site-header')
        let _this = this

        var request = new XMLHttpRequest()
        request.responseType = 'document'
        request.open('GET', '/cart', true)
        request.onload = function () {
            if (request.status === 200) {
                // Update cart contents
                let newCartContainer = request.responseXML.querySelector('#cart-container')
                let newCartContainerOverlays = request.responseXML.querySelectorAll('.cart-overlay')
                let newCartSticky = request.responseXML.querySelector('#cart-sticky-price')
                console.log(newCartSticky)

                currentCartContainer.innerHTML = newCartContainer.innerHTML
                // Update overlays
                currentCartOverlays.forEach(function (el) {
                    el.remove()
                })
                newCartContainerOverlays.forEach(function (el) {
                    _this._utils.insertAfter(el, siteHeader)
                })
                currentCartSticky.innerHTML = newCartSticky.innerHTML
                // Reinit cart page
                _this.onInit()
                _this._utils.initAccordion()
                _this._utils.anchorLink()
                _this._utils.overlayToggle()
                _this._utils.initOverlay()
                _this._utils.updateCartCounter()
            } else {
                alert('Error')
            }
        }
        request.onerror = function () {
            alert('Error')
        }
        request.send()
    }

    removeFromCart () {
        let allRemove = this._elem.querySelectorAll('.remove-cart-button')
        let _this = this
        let overlay = this._elem.querySelector('.image-overlay')

        allRemove.forEach(function (el) {
            el.addEventListener('click', function () {
                if (overlay) {
                    overlay.classList.remove('hide')
                }
                let lineItem = el.getAttribute('data-line-item')
                _this.ShopifyAPI.changeItem(lineItem, 0, () => _this.updateCartPage())
            })
        })
    }

    initCartNote () {
        let noteTextarea = this._elem.querySelector('#cart-note')
        let _this = this
        if (noteTextarea) {
            noteTextarea.addEventListener('change', function () {
                _this.ShopifyAPI.updateCartNote(noteTextarea.value, function (status) {
                    console.log(status)
                    _this._utils.updateCartCounter()
                })
            })
        }
    }

    mobileInit () {
        let _this = this
        let mobileTriggers = document.querySelectorAll('.mobile-overlay-trigger')
        let mobileSubmit = document.querySelectorAll('.mobile-overlay-submit')

        // On overlay value change, change main form select
        mobileTriggers.forEach(function (el) {
            el.addEventListener('click', function () {
                let target = el.getAttribute('data-overlay-link')
                let targetValue = el.getAttribute('data-value')
                let lineItem = el.getAttribute('data-line-item')
                let imageSrc = el.getAttribute('data-image-src')

                if (target && lineItem && targetValue) {
                    _this._elem.querySelector(target).value = targetValue
                    _this.updateCart(_this._elem.querySelector(lineItem), false)

                    // Show item is selected
                    let accordion = _this._utils.getClosestParent(el, '.accordion-panel')
                    let accordionHeader = accordion.previousElementSibling
                    let allTriggersInAccordion = accordion.querySelectorAll('.mobile-overlay-trigger')
                    allTriggersInAccordion.forEach(function (e) {
                        if (e.getAttribute('data-value') === targetValue) {
                            e.classList.add('filter-standard__option-selected')
                        } else {
                            e.classList.remove('filter-standard__option-selected')
                        }
                    })
                    accordionHeader.querySelector('.filter-standard__selected span').textContent = targetValue
                    if (imageSrc) {
                        accordionHeader.querySelector('img').setAttribute('src', imageSrc)
                    }
                }
            })
        })

        // On submit click, submit changes
        mobileSubmit.forEach(function (el) {
            el.addEventListener('click', function () {
                if (!el.classList.contains('hide-opacity-low')) {
                    let submitLineItem = el.getAttribute('data-line-item')
                    let lineItem = submitLineItem.replace('#cart-line-item-', '')

                    if (submitLineItem) {
                        // Close overlay
                        document.querySelector(`[data-overlay-toggle="#m-filter-overlay-${lineItem}"]`).click()
                        // Submit Cart
                        _this.updateCart(_this._elem.querySelector(submitLineItem))
                    }
                }
            })
        })
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Cart.js